module.exports = __webpack_public_path__ + "img/analysisIcon6.d3dc2e20.png";